import React from "react";
import { Switch, FormControlLabel } from "@mui/material";

const BaseSwitch = ({ label, ...checkboxProps }) => {
  return (
    <FormControlLabel
      label={label}
      control={<Switch checked={!!checkboxProps.value} {...checkboxProps} />}
    />
  );
};

export default BaseSwitch;
